"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Minus = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Minus"));

// Generated by script, don't edit it please.
var Minus = (0, _createSvgIcon["default"])({
  as: _Minus["default"],
  ariaLabel: 'minus',
  category: 'action',
  displayName: 'Minus'
});
var _default = Minus;
exports["default"] = _default;
module.exports = exports.default;